import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import { TelephoneContext } from "@/modules/lead-page/new/hooks/telephone-context.hook";
import { UUID } from "crypto";
import { ReactNode, useMemo } from "react";

export interface TelephoneContextValue {
  telephone: {
    editTelephoneModalOpen: boolean;
    setEditTelephoneModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleChangeTelephone: (e: React.ChangeEvent<HTMLInputElement>) => void;
    addTelephone: {
      handleAddTelephone: () => void;
      isLoadingAddTelephone: boolean;
      isAddingTelephone: boolean;
      isErrorAddTelephone: boolean;
      addTelephoneValidationError: string;
    };
    deleteTelephone: {
      handleDeleteTelephone: (telephoneId: UUID) => void;
      isLoadingDeleteTelephone: boolean;
      isErrorDeleteTelephone: boolean;
      telephoneIdToDelete: UUID | null;
      isDeletingTelephone: boolean;
      setTelephoneIdToDelete: React.Dispatch<React.SetStateAction<UUID | null>>;
    };
    makeTelephonePrimary: {
      handleMakeTelephonePrimary: (telephoneId: UUID) => void;
      isMakingTelephonePrimary: boolean;
      setTelephoneIdToMakeDefault: React.Dispatch<
        React.SetStateAction<UUID | null>
      >;
      telephoneIdToMakeDefault: UUID | null;
      isErrorMakeTelephonePrimary: boolean;
      errorMakeTelephonePrimary: unknown;
    };
    value:
      | {
          id: number;
          telephone: string;
          primary: boolean;
          uid: string;
          lead_id: number;
          deletedAt: string | null;
        }[]
      | string;
    telephoneList:
      | {
          id: number;
          telephone: string;
          primary: boolean;
          uid: string;
          lead_id: number;
          deletedAt: string | null;
        }[]
      | undefined;
    state: string;
    setTelephone: React.Dispatch<React.SetStateAction<string>>;
    isMakingTelephonePrimary: boolean;
  };
}

export function TelephoneProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  const { telephone } = useLeadInfo();

  const contextValue = useMemo(() => ({ telephone }), [telephone]);

  return (
    <TelephoneContext.Provider value={contextValue}>
      {children}
    </TelephoneContext.Provider>
  );
}
